import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transparent-header',
  templateUrl: './transparent.component.html',
  styleUrls: ['./transparent.component.css']
})
export class TransparentHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
